(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('ordiniApp')
        .constant('VERSION', "1.2.29")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
